import ApiService from '../../services/ApiService'
import store from '@/store/store'
import { filterFlag } from '@/const'
import swal from 'sweetalert'
import { app } from '@/main.js'

export const namespaced = true
export const state = {
  dashboardFilter: {
    organisationId: '',
    buildingId: '',
    flag: filterFlag.all,
    filterIds: []
  },
  areaFilters: [],
  buildings: []
}

export const mutations = {
  SET_DASHBOARD_FILTER: (state, dashboardFilter) => {
    state.dashboardFilter = dashboardFilter
  },
  SET_AREA_FILTERS: (state, areaFilters) => {
    state.areaFilters = areaFilters
  },
  SET_BUILDINGS: (state, buildings) => {
    state.buildings = buildings
  }
}

export const getters = {
  // Calculate the data of filter in the  API
  // If user only select organisation and building, use flag=3 for building filter. send list of building id in the body parameter
  calculatedFilter: () => {
    let filter = JSON.parse(JSON.stringify(state.dashboardFilter))
    if (
      filter.organisationId &&
      filter.buildingId &&
      filter.filterIds.length === 0
    ) {
      filter.flag = filterFlag.building
      filter.filterIds = [filter.buildingId]
    }
    return filter
  },
  // Human-readable names for the currently selected facility/floor/area,
  // for analytics. Multiple selected floors/areas are comma-separated.
  filterNames: state => {
    const { buildingId, flag, filterIds } = state.dashboardFilter
    const building = state.buildings.find(b => b.BuildingId === buildingId)
    const facilityName = building ? building.BuildingName : null

    let floorName = null
    if (flag === filterFlag.floor && building && building.Floors) {
      floorName =
        building.Floors.filter(floor => filterIds.includes(floor.FloorId))
          .map(floor => floor.FloorName)
          .join(', ') || null
    }

    let areaName = null
    if (flag === filterFlag.area) {
      areaName =
        state.areaFilters
          .filter(area => filterIds.includes(area.WardId))
          .map(area => area.Name)
          .join(', ') || null
    }

    return { facilityName, floorName, areaName }
  }
}

export const actions = {
  getAreaFilters({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService.GetBuildingAreas(store.state.filter.dashboardFilter.buildingId)
        .then(response => {
          commit('SET_AREA_FILTERS', response.data.data)
          resolve(response)
        })
        .catch(() => {
          reject(Error('Unknown Error'))
        })
    })
  },
  getBuildings({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService.GetBuildings(store.getters[`user/selecteOrganisationId`])
        .then(response => {
          let buildings = response.data.data
          commit('SET_BUILDINGS', buildings)

          // Show default option if only one building is available.
          let filter = state.dashboardFilter
          if (buildings && buildings.length === 1 && !filter.buildingId) {
            commit('SET_DASHBOARD_FILTER', {
              ...filter,
              buildingId: buildings[0].BuildingId
            })
          }
          resolve(response)
        })
        .catch(() => {
          reject(Error('Unknown Error'))
        })
    })
  },
  saveUserFilter({ commit }, filter) {
    return new Promise((resolve, reject) => {
      let filterIds = filter.filterIds
      if (filter.flag === filterFlag.building && filter.buildingId) {
        filterIds = [filter.buildingId]
      }
      ApiService.SaveUserFilter({
        OrganisationId: store.getters[`user/selecteOrganisationId`],
        FilterValue: JSON.stringify({
          OrganisationId: store.getters[`user/selecteOrganisationId`],
          BuildingId: filter.buildingId,
          FilterIds: filterIds,
          Flag: filter.flag
        })
      })
        .then(response => {
          if (response.data.success) {
            commit('SET_DASHBOARD_FILTER', filter)
          } else {
            swal({
              icon: 'error',
              title: app.$i18n.t('text.failed'),
              text: response.data.msg
            })
          }
          resolve(response)
        })
        .catch(() => {
          swal({
            icon: 'error',
            title: app.$i18n.t('text.failed')
          })
          reject(Error('Unknown Error'))
        })
    })
  },
  getUserFilter({ commit }) {
    return new Promise((resolve, reject) => {
      let orgId = store.getters[`user/selecteOrganisationId`]
      let deviceToken = store.getters[`user/deviceToken`]
      let isFromApp = !!deviceToken
      let requestIns = isFromApp
        ? ApiService.GetDeviceFilter(orgId, deviceToken)
        : ApiService.GetUserFilter(orgId)
      requestIns
        .then(response => {
          if (response.data.success) {
            let filter = null
            if (isFromApp) {
              filter = response.data.data
            } else if (response.data.data.FilterValue) {
              filter = JSON.parse(response.data.data.FilterValue)
            }

            if (filter) {
              let filterIds = filter.FilterIds
              if (filter.Flag === filterFlag.building && filter.BuildingId) {
                filterIds = []
              }
              // if flag is all, set filterIds to empty array, and buildingId to empty string
              if (filter.Flag === filterFlag.all) {
                filter.BuildingId = ''
                filter.FilterIds = []
                filterIds = []
              }
              commit('SET_DASHBOARD_FILTER', {
                organisationId: filter.OrganisationId,
                buildingId: filter.BuildingId,
                flag: filter.Flag,
                filterIds: filterIds
              })
            }
          } else {
            swal({
              icon: 'error',
              title: app.$i18n.t('text.failed'),
              text: response.data.msg
            })
          }
          resolve(response)
        })
        .catch(() => {
          swal({
            icon: 'error',
            title: app.$i18n.t('text.failed')
          })
          reject(Error('Unknown Error'))
        })
    })
  }
}
